import { saveAs } from "file-saver";
import groupBy from "lodash/fp/groupBy";
import moment from "moment";
class Controller {
  constructor($injector, $stateParams) {
    this.BulkBonus = $injector.get("Bulkbonuses");
    this.$stateParams = $stateParams;
    this.fields = [
      { name: "captain_id", title: "Captain Id" },
      { name: "invoice_id", title: "Invoice Id" },
      { name: "amount", title: "Amount" },
    ];
    this.fieldsWithDescription = [
      { name: "captain_id", title: "Captain Id" },
      { name: "invoice_id", title: "Invoice Id" },
      { name: "amount", title: "Amount" },
      { name: "description", title: "Description" },
    ];
  }

  $onInit() {
    this.BulkBonus.get(this.$stateParams.id).$promise.then((response) => {
      this.bulkbonus = response;
      this.items = response.records;
      this.groupedItems = groupBy((record) => record.status)(response.records);
    });
  }
  downloadCSV(data) {
    const newRowRegex = "\r\n";
    const filteredData = data.map((cell) => {
      return {
        captain_id: cell.captain_id,
        invoice_id: cell.invoice_id,
        amount: cell.amount,
        status: cell.status,
        description: cell.description,
      };
    });
    const columns = Object.keys(filteredData[0]).join(",") + newRowRegex;
    const rows = filteredData.reduce((rows, row) => {
      return rows.concat(Object.values(row).join(",") + newRowRegex);
    }, "");
    const parsedData = columns + rows;

    const csvFile = new File(
      [parsedData],
      `Bulk Bonus Upload ${moment(this.bulkbonus.createdAt).format("LL")}.csv`
    );
    saveAs(csvFile);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bulkBonusDetails/bulkBonusDetails.controller.js